<template>
  <div :class="$style.charge">
    <Charge @close="close" v-show="thirdChargeVisible" ref="chargeRef"></Charge>
    <AntiIndulged
      @antiIndulgedClose="antiIndulgedClose"
      v-if="antiIndulgedPayVisible"
      :class="$style.antiIndulged"
    ></AntiIndulged>
    <LargeCharge v-if="largeChargeVisible" @close="close" @back="closeLargeCharge"></LargeCharge>
    <GuideRemind v-if="guideRemindVisible" @close="close"></GuideRemind>
  </div>
</template>
<script>
import Charge from '@/components/charge/Charge'
import AntiIndulged from './anitiIndulged/antiIndulgedPay.vue'
import LargeCharge from '@/components/charge/LargeCharge.vue'
import GuideRemind from '@/components/charge/GuideRemind.vue'

import { isAndroid } from '@/libs/utils'
import { mapState } from 'vuex';
import {
  closeOrderFrame,
  innerPurchaseFunctionSuc,
  registFunReportFunction,
  checkOrderState,
  registReturnGameFunction
} from '@/bridge/AppJsBridge';

export default {
  data() {
    return {

    }
  },
  async mounted() {
    await this.$store.dispatch('user/getCacheState');
    this._clientInit()
  },
  computed: {
    ...mapState({
      thirdChargeVisible: state => state.pay.thirdChargeVisible,
      antiIndulgedPayVisible: state => state.pay.antiIndulgedPayVisible,
      largeChargeVisible: state => state.pay.largeChargeVisible,
      guideRemindVisible: state => state.pay.guideRemindVisible,
      open: state => state.pay.open,
    })
  },
  components: {
    Charge,
    AntiIndulged,
    LargeCharge,
    GuideRemind
  },
  methods: {
    _clientInit() {
      closeOrderFrame((data, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          orderShow: false,
          orderIframeLink: ""
        })
      });
      innerPurchaseFunctionSuc((data, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          yyb_info: JSON.parse(data)
        })
        this.$store.dispatch('pay/yybInnerPay')
        cb('yyb_Success');
      })
      registFunReportFunction((data, cb) => {
        // 将APP传过来没对应的数据做处理
        let orderInfo = JSON.parse(data);
        orderInfo.zfAmount = orderInfo.total_fee;
        this.$store.commit('pay/CHANGE_STATE', { order_info: orderInfo });
        this.$store.dispatch('pay/getPayTypeList', JSON.parse(data));
        this.$store.dispatch('pay/initTQLib');
      })
      checkOrderState((data, cb) => {
        this.$store.dispatch('pay/queryOrderResult');
      })
    },
    close() {
      registReturnGameFunction(null)
    },
    antiIndulgedClose() {
      if (this.open == 0 && !isAndroid()) {
        registReturnGameFunction(null);
      }
      this.$store.commit('pay/CHANGE_STATE', { antiIndulgedPayVisible: false });
      this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
    },
    closeLargeCharge() {
      this.$store.commit('pay/CHANGE_STATE', { largeChargeVisible: false });
      this.$refs.chargeRef && this.$refs.chargeRef.resetRadio();
    }
  }
}
</script>

<style lang="scss" module>
.charge {
  width: 100%;
  height: 100%;
  .antiIndulged {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
}
</style>